module.exports = __webpack_public_path__ + "img/productBgImg5.f303ec40.png";